import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {takeUntil} from 'rxjs/operators';
import {destroy$} from '../../components/destroyable';
import {Widget} from '../../components/layout/widget/widget';
import {WidgetLinkingGroupService} from '../../components/widget-linking-group';
import {DexLpDetailsWidget} from './dex-lp-details-widget';

@Component({
    selector:        'dex-lp-details-widget',
    templateUrl:     './dex-lp-details-widget.component.html',
    styleUrls:       ['./dex-lp-details-widget.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone:      false
})
export class DexLpDetailsWidgetComponent {

    public readonly destroy$ = destroy$();

    public readonly widget = inject(Widget) as DexLpDetailsWidget;
    public readonly widgetImpl = this.widget.implementationInstance;

    private readonly widgetLinkingGroupService = inject(WidgetLinkingGroupService);

    public handleToggleCollapsed(): void {
        this.widgetImpl.toggleFeatureCollapsed(false).pipe(
            takeUntil(this.destroy$)
        ).subscribe();
    }

    public handleSymbolClick(symbol: string): void {
        this.widgetLinkingGroupService.setLinkingGroupSettings(
            this.widget.linkingGroupId,
            this.widget.tabId,
            {
                trancheSymbol: symbol
            } as any
        );
    }

}
